<template>
  <div class="">
    <div
        v-for="note in notes"
        :key="note.id"
        class="mb-3 border-bottom cursor-pointer">
      <div
        @click="selectItem(note.id)"
        class="pt-2 px-3 position-relative">
        <div>{{note.text}}.</div>

        <div v-if="note.createdAt">
          <small class="text-muted">
            Создано {{formatDate(note.createdAt)}}
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatDate from '../../../utils/formatDate';

export default {
  name: 'ClientNote',

  props: ['notes'],

  data() {
    return {};
  },

  methods: {
    async selectItem(id) {
      this.$emit('select', id);
    },

    formatDate(date) {
      return typeof date === 'undefined' ? '' : formatDate(new Date(date), 'd.m.y');
    },
  },
};
</script>
